// extracted by mini-css-extract-plugin
module.exports = {"left":"Style_left__3bS6I","left_list":"Style_left_list__oX8NQ","active":"Style_active__1xuSE","from":"Style_from__2_cVE","fromGroup":"Style_fromGroup__nYljH"};